import React, { SVGProps } from 'react'

import { IconTemplateIPortIcon } from '@/shared/lib/@deprecated/iport-icons/template/IconTemplateIPortIcon'
import { CustomIconProps } from '@/shared/ui/icon-template'

export const SvgMir = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplateIPortIcon width={50} height={50} {...props}>
			<svg viewBox="0 0 44 14" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_13225_53450)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M11.8566 0.572266V0.577879C11.8512 0.577879 10.138 0.572266 9.68109 2.2618C9.2623 3.81101 8.08208 8.08816 8.04945 8.20604H7.72312C7.72312 8.20604 6.5157 3.83346 6.09147 2.25619C5.63461 0.566653 3.91595 0.572266 3.91595 0.572266H0V13.4262H3.91595V5.79242H4.07911H4.24228L6.52658 13.4262H9.24599L11.5303 5.79803H11.8566V13.4262H15.7726V0.572266H11.8566Z"
						fill="#4DB45E"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M26.1591 0.572266C26.1591 0.572266 25.0115 0.678914 24.4731 1.9194L21.6993 8.20604H21.373V0.572266H17.457V13.4262H21.1554C21.1554 13.4262 22.3574 13.3139 22.8958 12.0791L25.6152 5.79242H25.9416V13.4262H29.8575V0.572266H26.1591Z"
						fill="#4DB45E"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M31.6016 6.41016V13.4265H35.5175V9.32895H39.7598C41.609 9.32895 43.1754 8.11092 43.7573 6.41016H31.6016Z"
						fill="#4DB45E"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M39.7544 0.572266H31.0469C31.482 3.01956 33.2605 4.98414 35.5611 5.62402C36.0832 5.76996 36.6325 5.84855 37.1982 5.84855H43.9097C43.9695 5.55667 43.9967 5.25918 43.9967 4.95046C43.9967 2.53123 42.0985 0.572266 39.7544 0.572266Z"
						fill="url(#paint0_linear_13225_53450)"
					/>
				</g>
				<defs>
					<linearGradient
						id="paint0_linear_13225_53450"
						x1="31.0479"
						y1="3.21041"
						x2="43.9967"
						y2="3.21041"
						gradientUnits="userSpaceOnUse">
						<stop offset="0.3" stopColor="#00B4E6" />
						<stop offset="1" stopColor="#088CCB" />
					</linearGradient>
					<clipPath id="clip0_13225_53450">
						<rect width="44" height="12.8539" fill="white" transform="translate(0 0.572266)" />
					</clipPath>
				</defs>
			</svg>
		</IconTemplateIPortIcon>
	)
}
